import { MagoWebManagementComponent } from './magoweb-management/magoweb-management.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SubscriptionAccountComponent } from './account-console-test/subscription-account/subscription-account.component';
import { AccountCreateAccountComponent } from './account-console-test/account-create-account/account-create-account.component';
import { SubscriptionManagementComponent } from './account-console-test/subscription-management/subscription-management.component';
import { AccountManagementComponent } from './account-console-test/account-management/account-management.component';
import { ImportExportHomeComponent } from './account-console-test/import-export-management/import-export-home.component';
import { ImportManagementComponent } from './account-console-test/import-export-management/import-management/import-management.component';
import { ExportManagementComponent } from './account-console-test/import-export-management/export-management/export-management.component';
import { HistoryImpExpComponent } from './account-console-test/import-export-management/history-imp-exp/history-imp-exp.component';
import { UsersListComponent } from './my-users/users-list/users-list.component';
import { MyUsersComponent } from './my-users/my-users.component';
import { ProductsDownloadComponent } from './products-download/products-download.component';
import { MagoWebNfsComponent } from './magoweb-management/magoweb-nfs/magoweb-nfs.component';
import { MagowebDashboardComponent } from './magoweb-management/magoweb-dashboard/magoweb-dashboard.component';
import { RankingManagementComponent } from './ranking-management/ranking-management.component';
import { ProductViewerComponent } from './products-download/product-viewer/product-viewer.component';
import { ProductImprovementDetailsComponent } from './technical-support/product-improvement-details/product-improvement-details.component';
import { ProductBugDetailsComponent } from './technical-support/product-bug-details/product-bug-details.component';
import { ProductBugsReleasesFounderComponent } from './products-download/product-bugs-releases-founder/product-bugs-releases-founder.component';
import { MagoUniversityComponent } from './mago-university/mago-university.component';
import { MagoCoursesComponent } from './mago-university/mago-courses/mago-courses.component';
import { TrainingRequestComponent } from './mago-university/training-request/training-request.component';
import { TechnicalSupportComponent } from './technical-support/technical-support.component';
import { NotFoundComponent } from '../shared/components/not-found/not-found.component';
import { RoleGuardService } from '../guard/role-guard.service';
import { ST_Roles } from '../core/services/store-role.service';
import { ImprovementRequestsComponent } from './improvement-requests/improvement-requests.component';
import { BugsImprovementFinderComponent } from './technical-support/bugs-improvement-finder/bugs-improvement-finder.component';
import { CourseDetailComponent } from './mago-university/course-detail/course-detail.component';
import { FamilyProductsComponent } from './products-download/family-products/family-products.component';
import { M4passkeyGeneratorComponent } from './technical-support/m4passkey-generator/m4passkey-generator.component';
import { IncidentsFinder } from './technical-support/incidents-finder/incidents-finder.component';
import { MagocloudManagementComponent } from './magocloud-management/magocloud-management.component';
import { MagocloudDashboardComponent } from './magocloud-management/magocloud-dashboard/magocloud-dashboard.component';
import { VerticalSolutionsComponent } from './vertical-solutions/vertical-solutions.component';
import { VerticalSolutionsManagementComponent } from './vertical-solutions/vertical-solutions-management/vertical-solutions-management.component';
import { KeyGenerationComponent } from './vertical-solutions/key-generation/key-generation.component';
import { GenerateSerialNumbersComponent } from './vertical-solutions/generate-serial-numbers/generate-serial-numbers.component';
import { CryptSalesModulesComponent } from './vertical-solutions/crypt-sales-modules/crypt-sales-modules.component';
import { InsertNewSolutionComponent } from './vertical-solutions/insert-new-solution/insert-new-solution.component';
import { PartnershipGuardService } from '../guard/partnership-guard.service';
import { ProductCode } from '../model/industry';
import { ProductPartnershipLevel } from '../model/ProductPartnershipLevel';

const baseDownloadPartnership = {
    productPartnershipLevels: [
        new ProductPartnershipLevel('MAGO4', 'SILVER'),
        new ProductPartnershipLevel('MAGOCLD', 'SILVER'),
        new ProductPartnershipLevel('MAGOWEB', 'SILVER'),
    ],
    check: 'one',
};

const routes: Routes = [
    { path: 'subscription-account', component: SubscriptionAccountComponent },
    { path: 'create-account', component: AccountCreateAccountComponent },
    { path: 'subscription-management', component: SubscriptionManagementComponent },
    { path: 'account-management', component: AccountManagementComponent },
    { path: 'ranking-management', component: RankingManagementComponent },
    { path: 'import-export-home', component: ImportExportHomeComponent },
    { path: 'import-export-home/import-management', component: ImportManagementComponent },
    { path: 'import-export-home/export-management', component: ExportManagementComponent },
    { path: 'import-export-home/history-imp-exp', component: HistoryImpExpComponent },
    { path: 'my-users/users-list', component: UsersListComponent },
    { path: 'my-users/my-users', component: MyUsersComponent },

    {
        path: 'products-download/products-download',
        component: ProductsDownloadComponent,
        canActivate: [PartnershipGuardService],
        data: baseDownloadPartnership,
    },
    {
        path: 'products-download/product-viewer',
        component: ProductViewerComponent,
        canActivate: [PartnershipGuardService],
        data: baseDownloadPartnership,
    },
    {
        path: 'products-download/product-viewer/find',
        component: ProductBugsReleasesFounderComponent,
        canActivate: [PartnershipGuardService],
        data: baseDownloadPartnership,
    },
    {
        path: 'products-download/family-releases',
        component: FamilyProductsComponent,
        canActivate: [PartnershipGuardService],
        data: baseDownloadPartnership,
    },
    {
        path: 'products-download/product-viewer/improvements/details',
        component: ProductImprovementDetailsComponent,
        canActivate: [PartnershipGuardService],
        data: baseDownloadPartnership,
    },
    {
        path: 'products-download/product-viewer/bugs/details',
        component: ProductBugDetailsComponent,
        canActivate: [PartnershipGuardService],
        data: baseDownloadPartnership,
    },
    /*{ path: 'products-download/product-viewer/all-releases', component: ProductReleasesTable },
    { path: 'products-download/product-viewer/improvements', component: ProductImprovementsComponent },
    { path: 'products-download/product-viewer/bugs', component: ProductBugsComponent },,*/
    {
        path: 'mago-university/mago-university',
        component: MagoUniversityComponent,
    },
    { path: 'mago-university/mago-courses', component: MagoCoursesComponent },
    { path: 'mago-university/mago-courses/course-detail', component: CourseDetailComponent },
    { path: 'mago-university/training-request', component: TrainingRequestComponent },

    { path: 'amazon-dsp-management/amazon-dsp-management', component: NotFoundComponent },
    { path: 'amazon-dsp-management/amazon-dsp-stepper', component: NotFoundComponent },
    { path: 'magoweb-management/magoweb-management', component: MagoWebManagementComponent },
    {
        path: 'magoweb-management/magoweb-dashboard',
        component: MagowebDashboardComponent,
        canActivate: [RoleGuardService],
        data: { roles: [ST_Roles[ST_Roles.ST_INTERNAL].toString(), ST_Roles[ST_Roles.ST_PARTNER_MAGOWEB].toString()] },
    },
    { path: 'magoweb-management/magoweb-nfs', component: MagoWebNfsComponent },
    { path: 'contacts-info/contacts-info', component: NotFoundComponent },
    {
        path: 'technical-support/technical-support',
        component: TechnicalSupportComponent,
    },
    { path: 'technical-support/improvement-request', component: ImprovementRequestsComponent },
    { path: 'technical-support/bugs-improvement-finder', component: BugsImprovementFinderComponent },
    { path: 'technical-support/incidents-finder', component: IncidentsFinder },
    {
        path: 'technical-support/passkey-generator',
        component: M4passkeyGeneratorComponent,
        canActivate: [PartnershipGuardService],
        data: { productPartnershipLevels: [new ProductPartnershipLevel('MAGO4', 'GOLD')], check: 'all' },
    },
    { path: 'magocloud-management/magocloud-management', component: MagocloudManagementComponent },
    {
        path: 'magocloud-management/magocloud-dashboard',
        component: MagocloudDashboardComponent,
        canActivate: [RoleGuardService],
        data: { roles: [ST_Roles[ST_Roles.ST_INTERNAL].toString(), ST_Roles[ST_Roles.ST_PARTNER_MAGOCLOUD].toString()] },
    },
    {
        path: 'vertical-solutions',
        component: VerticalSolutionsComponent,
        canActivate: [RoleGuardService],
        data: { roles: [ST_Roles[ST_Roles.ST_INTERNAL].toString(), ST_Roles[ST_Roles.ST_RESELLER].toString()] },
    },
    {
        path: 'vertical-solutions/vertical-solutions-management',
        component: VerticalSolutionsManagementComponent,
        canActivate: [RoleGuardService],
        data: { roles: [ST_Roles[ST_Roles.ST_INTERNAL].toString(), ST_Roles[ST_Roles.ST_RESELLER].toString()] },
    },
    {
        path: 'vertical-solutions/key-generation',
        component: KeyGenerationComponent,
        canActivate: [RoleGuardService],
        data: { roles: [ST_Roles[ST_Roles.ST_INTERNAL].toString(), ST_Roles[ST_Roles.ST_RESELLER].toString()] },
    },
    {
        path: 'vertical-solutions/generate-serial-numbers',
        component: GenerateSerialNumbersComponent,
        canActivate: [RoleGuardService],
        data: { roles: [ST_Roles[ST_Roles.ST_INTERNAL].toString(), ST_Roles[ST_Roles.ST_RESELLER].toString()] },
    },
    {
        path: 'vertical-solutions/crypt-sales-modules',
        component: CryptSalesModulesComponent,
        canActivate: [RoleGuardService],
        data: { roles: [ST_Roles[ST_Roles.ST_INTERNAL].toString(), ST_Roles[ST_Roles.ST_RESELLER].toString()] },
    },
    {
        path: 'vertical-solutions/insert-new-solution',
        component: InsertNewSolutionComponent,
        canActivate: [RoleGuardService],
        data: { roles: [ST_Roles[ST_Roles.ST_INTERNAL].toString(), ST_Roles[ST_Roles.ST_RESELLER].toString()] },
    },

    { path: '**', redirectTo: 'account' },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: [RoleGuardService],
})
export class PortalRoutingModule {}
